import React from 'react';
import { AlertTriangle, MessageCircle } from 'lucide-react';
import { buildLowStockWhatsappLink } from '../../utils/storeLowStockAlert';

/**
 * Cartel de "quedan pocas unidades" para el carrito y el checkout.
 *
 * Es informativo: nunca bloquea la compra. Si la tienda cargó WhatsApp, suma un
 * botón con el mensaje prearmado y los productos en duda.
 *
 * `compact` lo achica para el panel del carrito (menos alto disponible).
 */
export default function LowStockNotice({ items = [], message, storeConfig, compact = false }) {
    if (!items.length) return null;

    const whatsappLink = buildLowStockWhatsappLink(storeConfig, items);

    return (
        <div className={`rounded-xl border border-amber-300 bg-amber-50 ${compact ? 'p-3' : 'p-4'}`}>
            <div className="flex gap-2">
                <AlertTriangle size={compact ? 16 : 18} className="text-amber-600 shrink-0 mt-0.5" />
                <div className="min-w-0 flex-1">
                    <p className={`font-bold text-amber-900 ${compact ? 'text-xs' : 'text-sm'}`}>
                        Últimas unidades
                    </p>
                    <p className={`text-amber-800 mt-0.5 ${compact ? 'text-[11px]' : 'text-xs'} leading-snug`}>
                        {message}
                    </p>
                    <ul className={`mt-2 space-y-0.5 ${compact ? 'text-[11px]' : 'text-xs'} text-amber-900`}>
                        {items.map((item) => (
                            <li key={item.id} className="truncate">
                                • {item.name}
                                <span className="opacity-70">
                                    {item.stock > 0 ? ` (queda${item.stock === 1 ? '' : 'n'} ${item.stock})` : ' (sin stock)'}
                                </span>
                            </li>
                        ))}
                    </ul>
                    {whatsappLink && (
                        <a
                            href={whatsappLink}
                            target="_blank"
                            rel="noreferrer"
                            className="mt-3 inline-flex items-center gap-1.5 rounded-lg bg-green-600 px-3 py-2 text-[11px] font-bold text-white transition-colors hover:bg-green-700"
                        >
                            <MessageCircle size={14} /> Consultar por WhatsApp
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}
